function LessonTableRow({ data, handleEdit, handleDelete }) {
    return <>
        <tr>
            <td>{new Date(data.dateOfMeeting).toLocaleDateString("en-GB")}</td>
            <td>{data.timeOfMeeting}</td>
            <td>{data.year}</td>
            <td>{data.subject}</td>
            <td>{data.professor}</td>
            <td>{data.studentBatch}</td>
            <td className="modify-lesson-col">
                <span onClick={handleEdit}>
                    <i className="fas fa-edit fa-2x"></i>
                </span>
                <span onClick={handleDelete}>
                    <i className="fas fa-trash fa-2x"></i>
                </span>
            </td>
        </tr>
    </>
}

export default LessonTableRow